import * as React from 'react';

import * as styles from './RequestFormModalFooter.css';

export interface IRequestFormModalFooterProps {
  personalAgreement: React.ReactElement;
  submitButton: React.ReactElement;
}

export const RequestFormModalFooter: React.FC<IRequestFormModalFooterProps> = ({ personalAgreement, submitButton }) => {
  return (
    <div className={styles['request-form-modal-footer']}>
      <div className={styles['personal-agreement-wrapper']}>{personalAgreement}</div>
      <div className={styles['button-wrapper']} data-testid="RequestFormSubmitButton">
        {submitButton}
      </div>
    </div>
  );
};
